export function truncateText(text, length) {
    if (text){
        let rv = text;
        if (text.length > length) {
            rv = text.slice(0, length) + '...';
        }
        return rv;
    }
}
